import { Link, NavLink } from "react-router-dom";
import "./App.css";
import Button from "./Components/Button";
import Navbar from "./Components/Navbar";

function Home() {
  return (
    <div>

    <Navbar />
    
    <div className="flex flex-col w-screen mt-20">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center">
        <div className="flex flex-col p-8 md:p-20">
          <p className="text-2xl md:text-4xl font-bold leading-relaxed">
            Rendering Opportunities, <br /> Creating Achievers!
          </p>
          <div className="flex flex-col md:flex-row items-stretch gap-6 mt-10 md:mt-20">
            <div className="flex flex-col gap-6">
              <p className="text-xl font-bold">For Job Posters</p>
              <p className="text-justify">
                Provide job Opportunity to the young learner and impart them
                work experience and practicum.
              </p>
              <Link to="/jobpost">
                <Button classN="bg-orange-500 text-white">Post A Job</Button>
              </Link>
            </div>
            <div className="flex flex-col gap-6">
              <p className="text-xl font-bold">For Job Seekers</p>
              <p className="text-justify">
                Grab the opportunity to develop new skills and work under good
                mentors and organization.
              </p>
              <Link to="/findjob">
                <Button color="white" classN="ring-2 ring-gray-200">
                  Find A Job
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <img className="order-first" src="home.png" alt="home.png" />
      </div>
    </div>
    </div>
  );
}

export default Home;
